import axiosInstance from 'interceptor/axiosInstance';
import { FuelAndEnergyDetails } from 'models/Farmbox/fuelAndEnergy.model';
import Notification from 'shared/components/Notification';
import { NotificationTypes } from 'enums/notificationTypes';
import { useState } from 'react';
import { generatePath } from 'react-router-dom';
import { ApiRoutes } from 'routes/routeConstants/apiRoutes';
import { deserialize } from 'serializr';
import { StageUpdatingMessage } from 'constants/constants';

const FarmFuelAndEnergyService = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [draftButtonLoading, setDraftButtonLoading] = useState<boolean>(false);

  const { STAGE_3 } = StageUpdatingMessage;

  const [fuelAndEnergyData, setFuelAndEnergyData] =
    useState<FuelAndEnergyDetails>();

  const fetchFuelAndEnergyData = async (
    pathParams: {
      commodityId?: string;
    },
    isLiveStock?: boolean
  ) => {
    const { commodityId } = pathParams;

    try {
      setLoading(true);
      const url = generatePath(
        isLiveStock
          ? ApiRoutes.LIVE_STOCK_FUEL_AND_ENERGY
          : ApiRoutes.CREATE_COMMODITY_FUEL_AND_ENERGY,
        {
          commodityId,
        }
      );
      const response = await axiosInstance.get(url);

      const fuelAndEnergyResponse = deserialize(
        FuelAndEnergyDetails,
        response.data
      );
      setFuelAndEnergyData(fuelAndEnergyResponse);
      return fuelAndEnergyResponse;
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const updateFuelAndEnergyDataAsDraft = async (
    commodityId?: string,
    isDraft?: boolean,
    isLiveStock?: boolean,
  ) => {
    try {
      isDraft ? setDraftButtonLoading(true) : setButtonLoading(true);
      const url = generatePath(isLiveStock
        ? ApiRoutes.LIVE_STOCK_FUEL_AND_ENERGY
        : ApiRoutes.CREATE_COMMODITY_FUEL_AND_ENERGY, {
        commodityId,
      });
      await axiosInstance.put(
        url,
        {},
        {
          params: {
            draft: isDraft
          },
        }
      ); // We dont need to send the payload as BE has the data already
      Notification({
        message: STAGE_3,
        description: '',
        type: NotificationTypes.SUCCESS,
      });
      return true;
    } catch (error) {
      return false;
    } finally {
      isDraft ? setDraftButtonLoading(false) : setButtonLoading(false);
    }
  };
  return {
    loading,
    fetchFuelAndEnergyData,
    fuelAndEnergyData,
    updateFuelAndEnergyDataAsDraft,
    draftButtonLoading,
    buttonLoading,
  };
};
export default FarmFuelAndEnergyService;
